import { Component, DestroyRef, ElementRef, inject, Input, TemplateRef, ViewChild } from '@angular/core';
import { NgFor, NgIf, DatePipe } from '@angular/common';
import { MatSortModule, Sort } from '@angular/material/sort';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PaginationComponent } from '../../elements/pagination/pagination.component';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';


import { User, Tenant } from '../../models/users.model';
import { provideNativeDateAdapter } from '@angular/material/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { OwnerAddComponent } from './owner-add/owner-add.component';
import { BreadcrumbComponent } from '../../elements/breadcrumb/breadcrumb.component';
import { debounceTime, distinctUntilChanged, filter, Subject, Subscription, switchMap, tap } from 'rxjs';
import { NgxToastrService } from '../../_services/ngx-toastr/ngx-toastr.service';
import { HttpServiceService } from '../../services/http-service.service';
import { Select2, Select2Data } from 'ng-select2-component';
import { NgSelectModule } from '@ng-select/ng-select';
import { Offcanvas } from 'bootstrap';
import { USER_PERMISSIONS, APP_CONSTANTS } from '../../app.constants';
import { LocalStorageService } from '../../services/local-storage.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-owners',
  imports: [NgIf, ReactiveFormsModule, NgbModule, MatSortModule, PaginationComponent, RouterModule, OwnerAddComponent, BreadcrumbComponent, NgFor, Select2, NgSelectModule, DatePipe],
  providers: [provideNativeDateAdapter()],
  templateUrl: './owners.component.html',
  styleUrl: './owners.component.css'
})
export class OwnersComponent {
  // offcanvasExample: boolean = false;
  offcanvasSearch: boolean = false;
  searchForm!: FormGroup;
  today: Date = new Date();
  private modalService = inject(NgbModal);
  itemDetails: any;
  breadcrumbList = {
    breadcrumb_path: 'Dashboard',
    currentURL: 'Owners',
    breadcrumb_url: '/admin/owners'
  }
  @ViewChild(OwnerAddComponent) owner!: OwnerAddComponent;
  private getAllOwnersSubscription?: Subscription;
  private getAllPropertiesSubscription?: Subscription;
  searchInput$ = new Subject<string>();
  offset_limit: number = 20;
  hasMore: boolean = true;
  lastSearchTerm: any;
  page: any = 1;
  totalRows: number = 20;
  totalPage: any = 0;
  disableClear: boolean = false;
  cities_list: Select2Data = [];
  states_list: Select2Data = [];
  propertiesList: any = [];
  @ViewChild('advancedSearchPopup') searchcanvas!: ElementRef;
  private searchInstance: Offcanvas | null = null;
  advancedSearchForm!: FormGroup;
  orderData: Tenant[] = [];
  allUsers: any = [];
  private deleteUserSubscription?: Subscription;
  private getAllUsersSubscription?: Subscription;
  private authService = inject(LocalStorageService);
  pageCount: number = 1;
  sortBy : string = '';
  orderBy : string = '';
  private destroyRef = inject(DestroyRef);
  users: Select2Data = [];

  constructor(private fb: FormBuilder, private alertService: NgxToastrService, private httpService: HttpServiceService, private route: ActivatedRoute, private router : Router) {

    this.searchForm = this.fb.group({
      address: [''],
      contact_no: [''],
      search: [''],
      city: [''],
      state: [''],
      property: [null],
      status: [null],
      managed_by: ['']
    });

    this.advancedSearchForm = this.fb.group({
      address: [''],
      phone: ['']
    });

    // this.orderData = this.allUsers.slice();
  }


  @Input() checkbox: boolean = false;

  active = 1;
  allData: any = [];
  boxActive: Boolean = false;
  disableDate: boolean = true;
  queryParamsSubsscription?: Subscription;
  isQueryParamsExists : boolean = false;


  ngOnInit(): void {
    let cities = this.route.snapshot.data['data']?.["data"] ?? [];
    for (let city of cities) {
      this.cities_list.push(
        {
          value: city,
          label: city,
          data: { name: city }
        }
      )
    };
    let states = this.route.snapshot.data['states']?.["data"] ?? [];
    for (let state of states) {
      this.states_list.push({
        value: state,
        label: state,
        data: { name: state }
      })
    };
    // this.getAllOwners();
    this.getAllProperties();
    if(this.checkManagedByFilter) this.getAllUsers();

    this.searchForm.get('search')?.valueChanges
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(value => {
        if(!this.isQueryParamsExists) this.handleSearch(value);
      });

    this.searchInput$
      .pipe(
        debounceTime(300),
        takeUntilDestroyed(this.destroyRef),
        filter(term => {
          const skip = term === this.lastSearchTerm;
          return !skip;
        }),
        tap((term) => {
          this.page = 1;
          this.hasMore = true;
          this.lastSearchTerm = term;
        }),
        switchMap(term => {
          return this.httpService.getAllProperties(1, 20, "&name=" + term);
        }
        )
      )
      .subscribe(results => {
        let propertiesList = results.data["properties"] ?? [];
        if (propertiesList.length >= results.data["total"]) {
          this.hasMore = false;
        }
        this.propertiesList = [];
        for (let resp of propertiesList) {
          this.propertiesList.push(
            {
              value: resp.uid,
              label: resp.name,
              data: { name: resp.name }
            }
          )
        }
      });
      this.queryParamsSubsscription = this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      let resp = { ...data };
      if(resp.page){
         this.page = parseInt(resp.page);
         delete resp.page;
         const hasAnyValue = Object.values(resp).some(value => !!value);
         if(hasAnyValue){
          let formObj = { property: null, status : null, ...resp };
          this.isQueryParamsExists = true;
          queueMicrotask(() => {
           this.searchForm.patchValue(formObj);
          });
         }
         this.handleSearch('', "keepPage", resp);
      }else{
        this.isQueryParamsExists = false;
        this.page = 1;
        this.getAllOwners();
      }
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const searchCanvasElement = this.searchcanvas?.nativeElement;
      if (searchCanvasElement) {
        Offcanvas.getOrCreateInstance(searchCanvasElement, {
          backdrop: 'static',
          keyboard: false,
        });
      }

    });
  }

  getAllOwners(query: any = '') {
    this.getAllOwnersSubscription = this.httpService.getAllOwners(this.page, this.offset_limit, query).subscribe({
      next: (response) => {
        this.orderData = response['data']?.["users"];
        this.totalRows = this.offset_limit;
        this.allData = this.paginator(this.orderData, this.page, this.totalRows);
        this.totalPage = response.data.total;
        this.pageCount = response.data.pageCount;
        if (this.offcanvasSearch) this.advancedPropertyClose();
      }
    })
  }

  viewOwner(uid : string){
    let data = {
      ...this.searchForm.value,
      page : this.page
    }
    this.router.navigate(['/admin/owner-details/overview', 'owner' ,uid], {
      queryParams: data
    });
  }

  redirectToProperty(uid : string){
    if(!uid) return;
    this.closeModal();
    this.router.navigate(['admin', 'properties', 'property-view', uid, 1]);
  }


  disableFutureDates = (date: Date | null): boolean => {
    return date ? date <= this.today : false;
  }

  toggleOwner(data: any) {
    //this.offcanvasExample = !this.offcanvasExample;
    this.owner.addPropertyEvent();
  }

  toggleSearch() {
    this.offcanvasSearch = !this.offcanvasSearch;
  }

  addPropertySearchToggle() {
    this.offcanvasSearch = !this.offcanvasSearch;
    if (this.searchInstance && this.offcanvasSearch) {
      this.searchInstance.show();
    }
  }

  advancedPropertyClose() {
    this.addPropertySearchToggle();
    if (this.searchInstance) {
      this.searchInstance.hide();
      this.advancedSearchForm.reset();
    }
  }

  advancedSearch() {
    let advancedSearchData = this.advancedSearchForm.value;
    let obj = {
      ...this.searchForm.value,
      ...advancedSearchData
    };
    let query = '';
    for (let key in obj) {
      if (obj[key]) {
        query += `&${key}=${obj[key]}`;
      }
    }
    if(this.orderBy) {
      query += `&sortBy=${this.sortBy}&orderBy=${this.orderBy}`;
    }
    this.page = 1;
    this.disableClear = true;
    this.getAllOwners(query);
  }

  resetSearchForm() {
    this.page = 1;
    this.sortBy = '';
    this.orderBy = '';
    this.searchForm.reset({
      total_bedrooms: '',
      status: ''
    }, { emitEvent: false });
    this.getAllOwners();
    this.disableClear = false;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {},
    });
    this.isQueryParamsExists = false;
  }

  openCenter(content: TemplateRef<any>, properties: any) {
    this.itemDetails = properties;
    this.modalService.open(content, { centered: true, backdrop: 'static' });
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  onSubmit(): void {
    // if (this.userForm.valid) {
    //   console.log('Form Data:', this.userForm.value); // Form values on submission
    //   //this.userForm.reset();
    //   //this.router.navigate(['/', 'admin']);
    // } else {
    //   console.log('Form is invalid.');
    // }
  }

  onSearch(): void {
    console.log(this.searchForm.value);
  }

  ownerClose() {
    this.owner.propertyClose();
  }

  selectUser(userId: string) {
    this.ownerClose();
    let userData = this.allData.data.find((user: User) => user.uid == userId);
    // this.userForm.patchValue(userData);
  }

  close() {
    this.ownerClose();
    // this.userForm.reset();
  }

  searchClose() {
    this.searchForm.get('address')?.setValue('');
    this.searchForm.get('contact_no')?.setValue('');
    this.toggleSearch();
  }

  handleSearch(value: any, keepPage: string = '', data : any = '') {
    const searchData = data ? data : this.searchForm.value;
    let query = '';
    for (let key in searchData) {
      if (searchData[key]) {
        query += `&${key}=${searchData[key]}`;
      }
    }
    if(this.sortBy) query += `&sortBy=${this.sortBy}&orderBy=${this.orderBy}`;
    if (!keepPage) this.page = 1;
    if (query || !value) {
      this.getAllOwners(query);
      this.disableClear = (value || query) ? true : false;
    }
  }

  onScrollToEnd() {
    // Optional: For pagination / infinite scroll
    if (!this.hasMore) return;
    this.page += 1;
    this.offset_limit += 20;
    this.getAllPropertiesSubscription = this.httpService.getAllProperties(this.page, this.offset_limit).subscribe(response => {
      let resp = response.data["properties"] ?? [];
      if (this.propertiesList.length >= response.data["total"]) {
        this.hasMore = false;
      }
      let properties = [];
      for (let property of resp) {
        properties.push(
          {
            value: property.uid,
            label: property.name,
            data: { name: property.name }
          }
        )
      }
      this.propertiesList = [...this.propertiesList, ...properties];
    });
  }

  getAllProperties(query: any = '') {
    this.getAllPropertiesSubscription = this.httpService.getAllProperties(this.page, this.offset_limit).subscribe({
      next: (response) => {
        let propertiesList = response.data["properties"] ?? [];
        if (this.propertiesList.length >= response.data["total"]) {
          this.hasMore = false;
        }
        this.propertiesList = [];
        for (let resp of propertiesList) {
          this.propertiesList.push(
            {
              value: resp.uid,
              label: resp.name,
              data: { name: resp.name }
            }
          )
        }
      }
    })
  }

  deleteUser(uid: string) {
    this.deleteUserSubscription = this.httpService.deleteUser(uid).subscribe({
      next: (response) => {
        this.alertService.success(response.message, "toast-top-right");
        this.getAllOwners();
      }
    })
  }




  sortData(sort: Sort) {
    if (!sort.active || sort.direction === '') {
      return;
    }
    this.sortBy = sort.active;
    this.orderBy = sort.direction;
    this.advancedSearch();
  }

  pageChange(e: any) {
    if (e == this.page) return;
    this.page = e;
    this.handleSearch('', "keepPage");
  }

  paginator(items: any, current_page: any, per_page_items: any) {
    let page = current_page || 1,
      per_page = per_page_items || 10,
      offset = (page - 1) * per_page,

      paginatedItems = items,
      total_pages = Math.ceil(items.length / per_page);

    return {
      page: page,
      per_page: per_page,
      pre_page: page - 1 ? page - 1 : null,
      next_page: (total_pages > page) ? page + 1 : null,
      total: items.length,
      total_pages: total_pages,
      data: paginatedItems,
      startPage: offset + 1,
      endPage: page * per_page,
    };
  }

  checkUncheckAll() {
    if (this.boxActive) {
      this.boxActive = false;
    } else {
      this.boxActive = true;
    }
  }

  addOwner(data: any) {
    this.getAllOwners();
  }

  ngOnDestroy() {
    this.getAllOwnersSubscription?.unsubscribe();
    this.getAllPropertiesSubscription?.unsubscribe();
    this.deleteUserSubscription?.unsubscribe();
    this.queryParamsSubsscription?.unsubscribe();
    this.getAllUsersSubscription?.unsubscribe();
  }

  get checkAddOwner(){
      return this.authService.checkPermission(USER_PERMISSIONS.OWNERS.OWNERS_ADD);
  }

  get checkViewOwner(){
    return this.authService.checkPermission(USER_PERMISSIONS.OWNERS.OWNERS_VIEW);
  }

  get checkDeleteOwner(){
    return this.authService.checkPermission(USER_PERMISSIONS.OWNERS.OWNERS_DELETE);
  }

  get checkManagedByFilter() {
    return this.authService.checkPermission(USER_PERMISSIONS.PROPERTIES.PROPERTY_MANAGED_BY_FILTER);
  }

  getAllUsers(){
    let query = `&role_identifier=${APP_CONSTANTS.USER_ROLES.PROPERTY_MANAGER}`;
    this.getAllUsersSubscription = this.httpService.getAllUsers(1, 200, query).subscribe({
      next : (response) => {
        for(let user of response.data.users){
            this.users.push(
              {
                value: user.uid,
                label: user.first_name + user.last_name,
                data: { name: user.first_name + user.last_name }
              }
            )
        }
      },
      error : (error) => {
        console.log(error);
      }
    })
  }

}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
